/**
 * @generated SignedSource<<b90019ffe73cfb44013e417d7f8b2f5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDesignYourOwnPillLazy_item$data = {
  readonly isDyoCustomizable: boolean | null;
  readonly " $fragmentType": "PdpSharedDesignYourOwnPillLazy_item";
};
export type PdpSharedDesignYourOwnPillLazy_item$key = {
  readonly " $data"?: PdpSharedDesignYourOwnPillLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDesignYourOwnPillLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDesignYourOwnPillLazy_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDyoCustomizable",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c33d96924ef527f3ecab7ba79f44ad37";

export default node;
